import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { AdminerProvider, createFetchClient } from "@marekl/adminer";
import { createRestAuthAdapter } from "@marekl/adminer/auth-rest-default";
import "@marekl/adminer/styles";
import "dayjs/locale/cs";
import { setupDayjs } from "@marekl/adminer/datetime";
import { configureFormatting } from "@marekl/adminer/format";
import { configureNotify } from "@marekl/adminer/api";
import { resolveTranslator } from "@marekl/adminer/util";
import csDict from "@marekl/adminer/i18n/cs";
import { queryClient } from "./lib/queryClient";
import { LinkComponent } from "./lib/LinkComponent";
import { ErrorBoundary } from "@marekl/adminer/components";
import App from "./App";
import "./index.css";

setupDayjs({ timezone: "Europe/Prague", locale: "cs" });
configureFormatting({
  locale: "cs-CZ",
  currency: "CZK",
  dateFormat: "DD.MM.YYYY",
  dateTimeFormat: "DD.MM.YYYY HH:mm",
  timeFormat: "HH:mm",
});
configureNotify({ t: resolveTranslator(csDict) });

const apiClient = createFetchClient({ baseUrl: "/api" });
const authAdapter = createRestAuthAdapter({ api: apiClient });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AdminerProvider
            api={apiClient}
            auth={authAdapter}
            i18n={csDict}
            LinkComponent={LinkComponent}
          >
            <App />
          </AdminerProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
